import { useState } from 'react';

export type SwitchProps = {
  initialToggled: boolean;
  onActivate: () => void;
  onDeactivate: () => void;
  className?: string;
};

export default function Switch({
  initialToggled,
  onActivate,
  onDeactivate,
  className = '',
}: SwitchProps) {
  const [toggled, setToggled] = useState(initialToggled);

  function onClick() {
    toggled ? onDeactivate() : onActivate(); //change to if/else?
    setToggled(!toggled);
  }

  return (
    <button
      className={
        className +
        ' w-12 h-6 border-2 rounded-xl hovor:shadow-sm transition-all duration-300 ease-in-out ' +
        (toggled
          ? 'bg-confirmed-secondary border-confirmed-secondary'
          : 'bg-gray-600 border-gray-700')
      }
      onClick={onClick}
    >
      <div
        className={
          'shadow-sm bg-white rounded-xl w-4 h-4 absolute top-0.5 ' +
          (toggled ? 'right-1' : 'left-1')
        }
      />
    </button>
  );
}
